export type FirstTouchAttribution = {
  source?: string;
  medium?: string;
  campaign?: string;
  partnerCode?: string;
  userReferralCode?: string;
  landingPage?: string;
  firstTouchAt?: string;
};

const STORAGE_KEY = 'clubiq_first_touch';

function readStored(): FirstTouchAttribution {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

/** Capture UTM / partner / user-ref on first visit. Never overwrite. */
export function captureFirstTouchFromLocation(
  search: string,
  pathname: string
): FirstTouchAttribution {
  const existing = readStored();
  const params = new URLSearchParams(search);
  const incoming: FirstTouchAttribution = {
    source: params.get('utm_source') || undefined,
    medium: params.get('utm_medium') || undefined,
    campaign: params.get('utm_campaign') || undefined,
    partnerCode: (params.get('partner') || params.get('p') || '').toUpperCase() || undefined,
    userReferralCode: (params.get('ref') || '').toUpperCase() || undefined,
    landingPage: pathname || '/',
    firstTouchAt: new Date().toISOString(),
  };

  const merged: FirstTouchAttribution = {
    source: existing.source || incoming.source,
    medium: existing.medium || incoming.medium,
    campaign: existing.campaign || incoming.campaign,
    partnerCode: existing.partnerCode || incoming.partnerCode,
    userReferralCode: existing.userReferralCode || incoming.userReferralCode,
    landingPage: existing.landingPage || incoming.landingPage,
    firstTouchAt: existing.firstTouchAt || incoming.firstTouchAt,
  };

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
  } catch {
    // ignore quota
  }
  return merged;
}

export function getFirstTouch(): FirstTouchAttribution {
  return readStored();
}
